export const styles = theme => ({
    root: {
      marginTop: theme.spacing(2),
      padding : theme.spacing(3),
      width : '100%',
      boxSizing: 'border-box'
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom : '8px',
    },    
    marginTop: {
      marginTop: theme.spacing(3), 
    },
    customFormLabel: {
      display: 'block',
      transformOrigin: 'top left',
      transform: 'translate(0, 1.5px) scale(0.75)',
      color: 'rgba(0, 0, 0, 0.85)',
      fontWeight: '500'
    }, 
    inputType: {
      height: 'unset'
    }
  });